import { useMainStore } from '@/store';
import _isEmpty from 'lodash/isEmpty';

export async function useSeo(url) {
  const store = useMainStore();
  const currentSEO = ref({});

  const seoKey = `seo-${url}`;

  const { data: tempSEO } = await useAsyncData(seoKey, () =>
    store.loadSeo({ url })
  );

  if (!_isEmpty(tempSEO.value)) {
    currentSEO.value = useLocaleSEO(tempSEO);
  }

  return currentSEO;
}
